export const FETCH_CURRENCY_CONVERSION_REQUEST = 'FETCH_CURRENCY_CONVERSION_REQUEST'
export const FETCH_CURRENCY_CONVERSION_FAILURE = 'FETCH_CURRENCY_CONVERSION_FAILURE'
export const FETCH_CURRENCY_CONVERSION_SUCCESS = 'FETCH_CURRENCY_CONVERSION_SUCCESS'
export const FETCH_CURRENCIES_SUCCESS = 'FETCH_CURRENCIES_SUCCESS'